// extracted by mini-css-extract-plugin
export default {"empty":"PaidInvoicesPage_empty__bEqCm"};